import { render, staticRenderFns } from "./LeadImport.vue?vue&type=template&id=39f317a0&"
import script from "./LeadImport.vue?vue&type=script&lang=js&"
export * from "./LeadImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports